export enum PropertyProfileTemplateEnum {
  Deco = 'prime',
  Modern = 'story'
}
